export const CANCEL_SOURCES = {
  RECORDS_FILTER: 'records-filter',
  PRODUCTS_FILTER: 'products-filter',
  PRODUCTS_VIEWS: 'products-views',
  AI_CHAT_RECORD_LIST: 'ai-chat-record-list',
  AI_CHAT_COMPANY_LIST: 'ai-chat-company-list',
  AI_CHAT_MESSAGES: 'ai-chat-messages',
  AI_CHAT_ATTACHMENTS: 'ai-chat-attachments',
  AI_CHAT_UPLOAD: 'ai-chat-upload',
  MENTION_SEARCH: 'mention-search',
  KANBAN_BOARD: 'kanban-board',
  // Kept separate from KANBAN_BOARD: that source is shared by every column
  // fetch (initial visible zone, lazy pairs, load-more), and a board rebuild
  // aborts whatever of those is in flight. The count request is a completely
  // independent endpoint fired on a different cadence (only when the filters
  // or status pills actually change) - sharing the source would let a
  // dropPrevious on either call incorrectly abort the other.
  KANBAN_BOARD_COUNT: 'kanban-board-count',
} as const

export type CancelSource = typeof CANCEL_SOURCES[keyof typeof CANCEL_SOURCES]
